import React, { useState } from "react";
import { Form } from "react-bootstrap";
import Common_Btn_Yellow from "../../common_component/common_btn_yellow/Common_Btn_Yellow";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import Success_Modal from "../../contact-us/success_modal/Success_Modal";
import { postData } from "../../../utils/api";

const Common_Inquiry_Form = ({ onClick }) => {
  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const country_code = [{ value: "91", label: "+91" }];

  const onSubmit = async (data) => {
    setIsSubmitting(true);

    const payload = {
      full_name: data.full_name,
      email: data.email,
      phone: data.phone,
      destination: data.destination,
      travel_date: data.travel_date,
      no_of_traveller: data.no_of_traveller,
      message: data.message,
    };

    try {
      const response = await postData("/master/package-inquiry/", payload);

      if (response?.success) {
        if (onClick) {
          onClick();
        }

        // setShowSuccessModal(true);

        // setTimeout(() => {
        //   setShowSuccessModal(false);
        // }, 3000);

        reset();
      } else {
        alert(response?.message || "Something went wrong");
      }
    } catch (error) {
      console.log(error);
      alert("Server error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Form className="inquiry-form" onSubmit={handleSubmit(onSubmit)}>
        <Form.Group className="input_group">
          <Form.Label>Full Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter your full name"
            {...register("full_name", { required: true })}
          />
        </Form.Group>

        <Form.Group className="input_group">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter your email address"
            {...register("email", { required: true })}
          />
        </Form.Group>

        <Form.Group className="input_group">
          <Form.Label>Phone Number</Form.Label>

          <div className="row">
            <div className="col-lg-3">
              <Controller
                name="country_code"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={country_code}
                    defaultValue={country_code[0]}
                  />
                )}
              />
            </div>

            <div className="col-lg-9">
              <Form.Control
                type="text"
                placeholder="Enter your phone number"
                {...register("phone", { required: true })}
              />
            </div>
          </div>
        </Form.Group>

        <Form.Group className="input_group">
          <Form.Label>Travel Destination</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter your travel destination"
            {...register("destination", { required: true })}
          />
        </Form.Group>

        <Form.Group className="input_group">
          <Form.Label>Travel Date</Form.Label>
          <Form.Control
            type="date"
            {...register("travel_date", { required: true })}
          />
        </Form.Group>

        <Form.Group className="input_group">
          <Form.Label>Number of Travelers</Form.Label>
          <Form.Control
            type="number"
            placeholder="Enter number of travelers"
            {...register("no_of_traveller")}
          />
        </Form.Group>

        <Form.Group className="input_group">
          <Form.Label>Message</Form.Label>
          <Form.Control
            as="textarea"
            placeholder="Enter your message"
            {...register("message")}
          />
        </Form.Group>

        <div className="inquiry_wrapper">
          <Common_Btn_Yellow
            type="submit"
            text={isSubmitting ? "Sending..." : "Send Inquiry"}
            disabled={isSubmitting}
          />
        </div>
      </Form>

      {/* <Success_Modal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        successText="Tour Booked!"
      /> */}
    </>
  );
};

export default Common_Inquiry_Form;
